import React, { useRef } from "react";
import { useLanguage } from "../../contexts/LanguageContext";

// Os separadores da pagina (spec do redesign, R2), no padrao de tabs do ARIA: as setas andam entre eles,
// so o ativo e ponto de tabulacao, e no telemovel rolam na horizontal dentro da sua faixa. Quem escolhe
// e a pagina, que guarda o separador no URL. O ativo sublinha-se a mint, a cor do que esta selecionado
// (R1), e fica tambem a negrito e com o aria-selected, para o estado nao ir so na cor.
export const TABS = ["overview", "adoption", "conversations", "content", "assistant", "technical"];
const MOVES = { ArrowRight: 1, ArrowLeft: -1 };

const PageTabs = ({ tabs, active, onChoose }) => {
  const { translate } = useLanguage();
  const buttons = useRef({});
  const onKeyDown = (event, index) => {
    let next;
    if (event.key in MOVES) next = (index + MOVES[event.key] + tabs.length) % tabs.length;
    else if (event.key === "Home") next = 0;
    else if (event.key === "End") next = tabs.length - 1;
    else return;
    event.preventDefault();
    onChoose(tabs[next]);
    buttons.current[tabs[next]]?.focus();
  };
  return (
    <div role="tablist" aria-label={translate("analyticsSections")} className="flex gap-1 overflow-x-auto">
      {tabs.map((tab, index) => {
        const selected = tab === active;
        return (
          <button
            key={tab}
            ref={(element) => {
              buttons.current[tab] = element;
            }}
            type="button"
            role="tab"
            id={`analytics-tab-${tab}`}
            aria-selected={selected}
            aria-controls="analytics-panel"
            tabIndex={selected ? 0 : -1}
            onClick={() => onChoose(tab)}
            onKeyDown={(event) => onKeyDown(event, index)}
            className="px-3 py-2 text-sm whitespace-nowrap border-b-2"
            style={{
              borderColor: selected ? "var(--color-mint)" : "transparent",
              color: selected ? "var(--color-text-primary)" : "var(--color-text-secondary)",
              fontWeight: selected ? 600 : 400,
            }}
          >
            {translate(`analyticsTab.${tab}`)}
            {tab === "technical" && (
              <span className="ml-1.5 text-[11px] px-1.5 py-px rounded" style={{ backgroundColor: "var(--color-surface-raised)" }}>
                Kodly
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default PageTabs;
